import {gql} from '@apollo/client';

export const GET_ORDER_HISTORY_BY_CLUB_ID= gql`
    query GetOrderHistoryByClubId($clubId: String, $includePhoneNumber: Boolean = false, $limit: Int, $offset: Int) {
      getOrderHistoryByClubId(clubId: $clubId, limit: $limit, offset: $offset) {
        id
        clubId
        clubName
        clubCity
        clubState
        clubCountry
        userName
        phoneNumber @include(if: $includePhoneNumber)
        orderDetails {
          serviceType
        count
        shelf
        gst
        mrp
        partnerBundlePrice
        platformFee
        customerBundlePrice
        }
        totalAmount
        totalGstAmount
      totalPlatformFee
      totalPartnerAmount
        purchaseDate
        paymentStatus
        reinstatement {
          shelf
          reinstatedCredits
          automatic
        }
      }
    }
`;

export const GET_ALL_ORDERS = gql`
    query getAllOrders($limit: Int, $offset: Int) {
    getAllOrders(limit: $limit, offset: $offset) {
        id
        clubId
        clubName
        clubCity
        clubState
        clubCountry
        userName
        phoneNumber
        orderDetails {
          serviceType
        count
        shelf
        gst
        mrp
        partnerBundlePrice
        platformFee
        customerBundlePrice
        }
        totalAmount
        totalGstAmount
      totalPlatformFee
      totalPartnerAmount
        purchaseDate
        paymentStatus
        razorpay_payment_id
        razorpay_order_id
        reinstatement {
          shelf
          reinstatedCredits
          automatic
        }
    }
    }
   `
;

export const GET_ORDER_BY_ID = gql`
    query getOrderById($orderId: String, $includePhoneNumber: Boolean = false) {
        getOrderById(orderId: $orderId) {
        id
        clubId
        clubName
        clubCity
        clubState
        clubCountry
        userName
        phoneNumber @include(if: $includePhoneNumber)
        orderDetails {
          serviceType
        count
        shelf
        gst
        mrp
        partnerBundlePrice
        platformFee
        customerBundlePrice
        }
        totalAmount
        totalGstAmount
      totalPlatformFee
      totalPartnerAmount
        purchaseDate
        paymentStatus
        razorpay_payment_id
        razorpay_order_id
        reinstatement {
          shelf
          reinstatedCredits
          automatic
        }
        }
    }
`
